export default __webpack_public_path__ + "static/media/ic_indonesia.b539d2b7.svg";